import { TriangleAlert } from 'lucide-react';
import { cn } from '@/lib/utils';
import { EMPTY, formatDate, formatPct } from '@/lib/format';
import { formatPct1, overdueText } from '@/pages/submissions/helpers';
import type { SubmissionListItem } from '@/pages/submissions/types';

/** Date cell that turns red with "(3 days overdue)" when `overdue` is a number of days. */
export function DateCell({ value, overdue }: { value: string | null | undefined; overdue: number | null }) {
  if (!value) return <span className="text-muted-foreground">{EMPTY}</span>;
  const isOverdue = overdue !== null;
  return (
    <span
      className={cn('whitespace-nowrap tabular-nums', isOverdue && 'font-medium text-destructive')}
      data-overdue={isOverdue ? 'true' : undefined}
    >
      <time dateTime={value}>{formatDate(value)}</time>
      {isOverdue ? <span className="ml-1 text-xs">({overdueText(overdue)})</span> : null}
    </span>
  );
}

/** Actual margin with a red marker when it is below the effective margin. */
export function ActualMarginCell({ item }: { item: SubmissionListItem }) {
  const actual = item.rates.actualMarginPct ?? item.computed.actualMarginPct;
  if (actual === null || actual === undefined) return <span className="text-muted-foreground">{EMPTY}</span>;
  const target = item.rates.effectiveMargin.marginPct;
  const below = actual < target - 1e-9;
  return (
    <span
      className={cn('inline-flex items-center gap-1 tabular-nums', below && 'font-medium text-destructive')}
      title={below ? `Below the effective margin of ${formatPct(target)}` : undefined}
    >
      {below ? (
        <TriangleAlert className="h-3.5 w-3.5" role="img" aria-label="Below the effective margin" />
      ) : null}
      {formatPct1(actual)}
    </span>
  );
}
